import React, { useCallback, useMemo, useState } from 'react';
import { AppButton, Box, Text } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import _ from 'lodash';
import styled from 'styled-components';

import { IResendStatusHistory, ResendItemType } from '../ResendSection.types';

import ResendHistoryItem from './ResendHistoryListItem';

interface Props {
  items?: IResendStatusHistory[];
  communicationType: ResendItemType;
}

const Gradient = styled(Box)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 35px;
  

  background:${({theme}) => `linear-gradient(0deg, ${theme.colors.canvas} 0%,rgba(255, 255, 255, 0.00) 100%)`} ;
`;

const MAX_VISIBLE_AMOUNT = 3;
const ResendHistoryList: React.FC<Props> = ({ items, communicationType }) => {
  const title = useMemo(() => {
    if (communicationType === ResendItemType.Email) {
      return 'Email Status';
    }
    if (communicationType === ResendItemType.Letter) {
      return 'Letter Status';
    }
    if (communicationType === ResendItemType.SMS) {
      return 'SMS Status';
    }
    return '';
  }, [communicationType]);

  const [isExpanded, setExpanded] = useState(false);


  const handleToggleExpand = useCallback(() => { 
    setExpanded(!isExpanded);
  }, [isExpanded]); 

  const isShowMoreMode = useMemo(() => {
    return (items?.length || 0) > MAX_VISIBLE_AMOUNT;
  }, [items?.length]);
  const showMoreAmount = useMemo(() => {
    return (items?.length || 0) - MAX_VISIBLE_AMOUNT;
  }, [items?.length]);
  const sortedItems = useMemo(() => {
    return _.reverse(_.sortBy(items, (o) => dayjs(o.datetime)));
  }, [items]);
  if (!sortedItems || !sortedItems.length) {
    return null;
  }
  return (
    <Box
      margin={{ left: 's' }}
      border={{ size: 'small', color: 'border2' }}
      round="container1Round"
      background="canvas"
      direction="column"
      overflow="hidden"
      width={{ min: '256px' }}
    >
      <Box direction="column" pad={{ top: 'l', left: 'l', right: 'l', bottom: 'l' }}>
        <Text size="large" weight={700}>
          {title}
        </Text>
        <Box direction="column" height={{ max: isExpanded ? '338px' : '154px' }} overflow={isExpanded ? 'auto' :'hidden'} style={{ position: 'relative' }}>
          {sortedItems.map((item) => (
            <div key={item.id}>
              <ResendHistoryItem key={item.id} date={item.datetime} status={item.status} />
              {_.last(sortedItems) !== item && (
                <Box margin={{ vertical: 'xxs' }} pad={{ left: 's' }}>
                  <Box height="8px" width="1px" background="border"></Box>
                </Box>
              )}
            </div>
          ))}
          {!isExpanded && isShowMoreMode && (
            <Gradient />
          )}
          
        </Box>
      </Box>

      {isShowMoreMode && (
        <AppButton width="100%" style={{ borderTopRightRadius: '0px', borderTopLeftRadius: '0px' }} onClick={handleToggleExpand}>
          { isExpanded ? 'Hide' : `Show More (${showMoreAmount})`}
        </AppButton>
      )}
    </Box>
  );
};

export default ResendHistoryList;
